import { lighten, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/**
 * sx for a paper wrapping a control that should be visually highlighted and centered
 */
export const emphasizedControl: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',

  backgroundColor: (theme) => lighten(theme.palette.background.paper, 0.08),
};
